import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCustomGradients = (gradients) =>
  setSiteMeta(['customization', 'customGradients'], gradients);

export default createCustomGradients;
